import {useEffect, useState} from 'react'

/*
 * Milliseconds until a prepkit expires, recomputed every second (169).
 *
 * Pulled out of ExpiringPrepKit so the navbar chip and the dashboard banner run off one clock. Two
 * independent intervals would drift apart by up to a second, which is visible when both are showing
 * a value that changes every second.
 *
 * `expired` is derived rather than stored: state that can be computed is state that can go stale.
 */
const useExpiryCountdown = (expiresAt) => {
	const [now, setNow] = useState(() => Date.now())

	useEffect(() => {
		const interval = setInterval(() => setNow(Date.now()), 1000)
		return () => clearInterval(interval)
	}, [])

	if (!expiresAt) return {msLeft: null, expired: false}

	const msLeft = new Date(expiresAt).getTime() - now
	return {msLeft, expired: msLeft <= 0}
}

export default useExpiryCountdown
